import { random } from "@common";

const deviceNameKey = "deviceName";

export const deviceId = (() => {
  let name = localStorage.getItem(deviceNameKey);
  if (!name) {
    name = `portal-${random()}`; //TODO: replace with uuid
    localStorage.setItem(deviceNameKey, name);
  }

  return name;
})();

export const userAgent = "PORTAL";
